<template>
    <div class="c-company-colors">
        <button
            class="c-btn c-btn--transparent js-company-color-opener"
            :class="{ 'is-active': isOpen, 'is-selected': isActive }"
            @click="handleToggleOnClick"
        >
          <img
              v-if="selectedColor"
              :src="thumbnail(selectedColor.custom_filter_icon_desktop, 'xs')"
              class="c-company-colors__dot"
          />
            {{ $t("CompanyColors.title") }}
            <i class="ico ico-chevron-down" aria-hidden="true"></i>
        </button>
        <div :class="['c-company-colors__window', 'c-form']" v-if="isOpen" @click.stop>
            <div class="c-form__item--checkbox">
                <input
                    @change="handleIsActiveChange"
                    v-model="isActive"
                    class="c-form__input"
                    type="checkbox"
                    id="accept_company_colors"
                    name="accept_company_colors"
                    data-custom="toggle"
                />
                <label for="accept_company_colors">
                    <span class="sc-toggle"></span>
                    <span class="sc-text">{{ $t("CompanyColors.title") }}</span>
                </label>
            </div>
            <div :class="['c-company-colors__list', { 'is-loading': isLoading }]" v-if="isActive">
                <div class="c-company-colors__color" v-for="color in colors" :key="color.id">
                    <input
                        type="radio"
                        :id="color.name"
                        :value="color.id"
                        v-model="selectedColorId"
                        @change="onColorChange"
                    />
                    <label :for="color.name">
                        <img
                            v-if="color.custom_filter_icon_desktop"
                            :src="thumbnail(color.custom_filter_icon_desktop, 'xs')"
                            alt=""
                            class="c-company-colors__preview"
                        />
                        <div class="c-company-colors__name">
                            {{ color.name }}
                        </div>
                    </label>
                </div>
            </div>
            <p class="c-company-colors__description" v-else v-html="translatedDescription" />
            <a v-if="isActive" :href="helpLink" class="c-link c-link--primary">
                {{ $t("CompanyColors.linkTitle") }}
            </a>
            <div class="c-company-colors__shadow" v-if="isActive" />
        </div>
    </div>
</template>
<script>
import { showOverlay, hideOverlay } from "./../../functions/overlay";
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";
import {thumbnail} from "Functions/thumbnail";

const lang = document.querySelector("html").getAttribute("lang");
let locale;

import(`../../locale/${lang}`).then((module) => {
    locale = module.Swal;
});

export default {
    created() {
        this.fetchData();
        if (this.selectedColorId) {
            this.isActive = true;
        }
    },
    props: {
        helpLink: {
            type: String,
        },
        selectedColorId: {
            type: String,
        },
    },
    data() {
        return {
            isOpen: false,
            colors: [],
            fetchCancelToken: null,
            isInitialized: false,
            fetchingColors: true,
            isActive: !!this.selectedColorId,
        };
    },
    computed: {
        isLoading() {
            return this.fetchingColors;
        },
        translatedDescription() {
            return this.$t("CompanyColors.disabledDescription", ["<strong>", "</strong>"]);
        },
        selectedColor() {
            return this.colors.find((color) => color.id === parseInt(this.selectedColorId));
        },
        selectedColorHex() {
            if (!this.selectedColor) {
                return;
            }
            return this.selectedColor.custom_hex;
        },
    },
    methods: {
      thumbnail,
        cancelFetchColors() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        fetchData() {
            this.cancelFetchColors();
            this.fetchColors();
        },
        fetchColors() {
            this.fetchingColors = true;

            client
                .get("/get-color-variations", {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.colors = Object.values(response.data.data);
                    this.updateAllCompanyColorPreviews();
                })
                .catch((error) => {})
                .finally(() => {
                    this.fetchingColors = false;
                });
        },
        onColorChange(element) {
            const colorHex = element.target.value;
            client
                .post(
                    `/change-color-variation`,
                    {
                        id: colorHex,
                    },
                    {
                        cancelToken: this.fetchCancelToken.token,
                    }
                )
                .then((response) => {
                    this.selectedColorId = response.data.data.id;
                    window.location.reload();
                })
                .catch((error) => {})
                .finally(() => {
                    this.updateAllCompanyColorPreviews();
                });
        },
        onColorReset() {
            client
                .post(`/reset-color-variation`, {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then(() => {
                    this.selectedColorId = null;
                    window.location.reload();
                })
                .catch((error) => {})
                .finally(() => {
                    this.updateAllCompanyColorPreviews();
                });
        },
        handleClickOutside($event) {
            if (
                this.isOpen &&
                !this.$el.contains($event.target) &&
                !$event.target.closest(".swal2-container") &&
                !$event.target.closest(".notify") &&
                !$event.target.closest(".js-company-colors-trigger")
            ) {
                this.toggleOpen(false);
            }
        },
        handleToggleOnClick(event) {
            event.preventDefault();
            this.toggleOpen();
        },
        toggleOpen(isOpened) {
            if (typeof isOpened !== "boolean") {
                isOpened = !this.isOpen;
            }
            this.isOpen = isOpened;

            if (isOpened) {
                document.addEventListener("click", this.handleClickOutside);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        handleIsActiveChange(event) {
            this.isActive = event.target.checked;
            if (!this.isActive) {
                this.onColorReset();
            }
            this.updateAllCompanyColorPreviews();
        },
        updateAllCompanyColorPreviews() {
            const colorPreviews = document.querySelectorAll(".js-company-color-preview");

            colorPreviews.forEach((div) => {
                if (this.selectedColorHex) {
                    div.classList.remove("ico-minus-circle");
                    div.classList.add("ico-dot");
                    div.style.color = this.selectedColorHex;
                } else {
                    div.classList.remove("ico-dot");
                    div.classList.add("ico-dashed-circle");
                    div.style.color = "";
                }
            });
        },
    },
    watch: {
        isOpen(value) {
            if (value) {
                showOverlay("company-colors");
                document.querySelector(".js-page-header").classList.add("is-company-colors-open");
            } else {
                if (document.querySelector(".js-navigation-toggle.is-active")) {
                    showOverlay("header");
                } else {
                    hideOverlay("company-colors");
                }
                document
                    .querySelector(".js-page-header")
                    .classList.remove("is-company-colors-open");
            }
        },
    },
};
</script>
